import { DraftField } from "@/components/cadastro/draft-field";
import { FormSection } from "@/components/ui/form-section";
import { CadastroLabels } from "@/lib/labels";

export function IdentitySection() {
	return (
		<FormSection title={CadastroLabels.sectionTitle.identity}>
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<DraftField fieldKey="name" span autoFocus />
				<DraftField fieldKey="cpf" />
				<DraftField fieldKey="rg" />
				<DraftField fieldKey="birth_date" />
				<DraftField fieldKey="sex" />
				<DraftField fieldKey="mother_name" />
				<DraftField fieldKey="marital_status" />
			</div>
		</FormSection>
	);
}
